import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { action, computed, observable } from 'mobx'
import type { SupportingItemInputBase } from '../supporting-item-input'

/**
 * Props for {@link DocumentSupportingItemInput}.
 */
export type DocumentSupportingItemInputProps =
  ModelProps<DocumentSupportingItemInput> & { type: 'Document' }

/**
 * Supporting item input for documents.
 */
export class DocumentSupportingItemInput
  extends Model<DocumentSupportingItemInput>
  implements SupportingItemInputBase
{
  @observable accessor documentTypeShortId = Id.none
  @observable accessor documentLongIds: readonly Id[] = []

  /** @inheritDoc */
  @computed get isCompleted() {
    return this.documentLongIds.length > 0
  }

  /**
   * Adds the document long ID to the list of provided documents.
   *
   * @param longId
   */
  @action.bound
  addDocument(longId: Id) {
    if (this.documentLongIds.includes(longId)) {
      return
    }

    this.documentLongIds = [...this.documentLongIds, longId]
  }

  /**
   * Removes the document long ID from the list of provided documents.
   *
   * @param id
   */
  @action.bound
  removeDocument(longId: Id) {
    if (!this.documentLongIds.includes(longId)) {
      return
    }
    this.documentLongIds = this.documentLongIds.filter(
      (docId) => docId !== longId,
    )
  }
}
